import React from 'react';
import PropTypes from 'prop-types';

import { ITEM_TYPES } from '../../constants';
import InfiniteRowsScene from '../InfiniteRowsScene';
import api from '../../utils/api';

class CaseList extends React.Component {
  static propTypes = {
    caseList: PropTypes.object,
  };

  render() {
    const { ...rest } = this.props;
    const prefaceText = '';
    // 'We&nbsp;develop an&nbsp;idea and strategy of&nbsp;the brand, create a&nbsp;graphics system that translates the idea, and transfer it&nbsp;to&nbsp;the digital environment.';

    return <InfiniteRowsScene loadMoreFunc={api.cases} page={ITEM_TYPES.case} prefaceText={prefaceText} {...rest} />;
  }
}

export default CaseList;



// WEBPACK FOOTER //
// ./src/scenes/CaseList/index.js